import Image from "@/components/Image";
import { Link } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import { cexs } from "./data";

export function Building() {
  return (
    <section className="pt-[120px] pb-10 px-4 sm:px-10">
      <div className="flex flex-col items-center gap-1 mb-10 lg:mb-[60px]">
        <p className="text-xl font-medium text-white/60 text-center uppercase">
          What we’re building
        </p>

        <h2 className="text-[2rem] lg:text-[3.25rem] leading-10 lg:leading-[60px] text-white font-medium text-center">
          We’re listed on prestigious CEX
        </h2>
      </div>

      <div className="flex items-center justify-center gap-4 lg:gap-10">
        {cexs.map((item, idx) => {
          return (
            <Link
              to={item.link}
              target="_blank"
              key={idx.toString()}
              data-tooltip-content={item.title}
              data-action={item.dataAction}
              className="w-[52px] lg:w-[60px] h-[52px] lg:h-[60px] my-anchor-element hover:scale-110 transition-all rounded-lg"
            >
              <Image
                src={item.img}
                className="w-full h-full object-cover rounded-2xl"
                alt="close"
                width={120}
                height={120}
              />
            </Link>
          );
        })}
      </div>

      <Tooltip
        anchorSelect=".my-anchor-element"
        place="top"
        className="!rounded-lg text-sm font-medium"
      />
    </section>
  );
}
